import { render } from "./MWUpdateAgenda.vue?vue&type=template&id=33cdfb46"
import script from "./MWUpdateAgenda.vue?vue&type=script&lang=js"
export * from "./MWUpdateAgenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__